import { useSelector } from 'react-redux';

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  return authReducer;
};
